<footer>
    <div class="footer-holder">
        <div class="footer-info" [ngClass]="{ 'content-hidden': !footerAddress }">
            <div class="footer-container">
                <p>
                    &copy;{{ currentYear }} Merry Maids SPC LLC | {{ footerAddress }} | All rights reserved. <br />Merry Maids services provided by independently owned and operated Franchises or by a corporate owned branch. Prices and services vary by location.
                </p>
                <p>
                    <a [href]="termsOfUseUrl">Terms of Use</a> |
                    <a [href]="privacyPolicyUrl"> Privacy Policy</a> |
                    <a [href]="accessibilityUrl"> Accessibility</a> |
                    <a [href]="doNotShareUrl"> Do Not Share/Sell My Info</a>
                </p>
            </div>
            <div class="footer-block">
                <a
                    href="https://www.servicemaster.com/our-brands/"
                    target="_blank"
                    class="footer-logo"
                    gaEvent="click"
                    gaCategory="footer_logo"
                >
                    <img
                        alt="Merry Maids"
                        src="assets/images/footer-logo.png"
                        title="A ServiceMaster Company"
                        width="215"
                        height="28"
                        loading="lazy"
                        fetchpriority="low"
                        decoding="async"
                    />
                </a>
            </div>
        </div>
    </div>
</footer>
